import React from 'react'
import { bem } from '@argos/utils'

const cn = bem({ prefix: 'lc-', block: 'message-button' })

export default () => (
  <button aria-label='Send Message' className={cn()} data-test={cn()} type='submit'>
    <span className={cn('inner')}>Send</span>
  </button>
)
